import React, { memo } from "react";
import numeral from "numeral";
import "./styles.css";

const Pill = ({ title, value, suffix = "", type = "STRING" }) => {
  const getFormattedValue = () => {
    switch (type) {
      case "INTEGER":
        return <span>
          {numeral(value).format("0,0.[00]")}
          {suffix}
        </span>;
      case "PERCENT":
        return <span>
          {numeral(value).format("0.00%")}
          {suffix}
        </span>;
      case "CURRENCY":
        return <span>
          {numeral(value).format("$0,0[.]00")}
          {suffix}
        </span>;
      case "STRING":
      default:
        return <span>
          {value}
          {suffix}
        </span>;
    }
  };

  return (
    <div className="pill-wrapper">
      {value ? getFormattedValue() : <span>--</span>}
      <span>{title}</span>
    </div>
  );
};

const SreoMetricsPillbox = ({ metrics = [] }) => (
  <div className="pill-box-wrapper">
    {metrics.map(metric => <Pill title={metric.title} value={metric.metricValue} suffix={metric.suffix} type={metric.type} />)}
  </div>
);

export default (memo)(SreoMetricsPillbox);
